// Invoice utility functions
import { InvoiceItem } from './data-store';

export const generateInvoiceNumber = (nextNum: number): string => {
  const year = new Date().getFullYear();
  return `INV-${year}${String(nextNum).padStart(5, '0')}`;
};

export const getNextInvoiceNumber = (invoices: InvoiceItem[]): number => {
  if (invoices.length === 0) return 1;
  
  const currentYear = new Date().getFullYear();
  const yearInvoices = invoices.filter(inv => {
    const invYear = parseInt(inv.no.split('-')[1].substring(0, 4));
    return invYear === currentYear;
  });
  
  return yearInvoices.length + 1;
};

export const calculateInvoiceStatus = (total: number, bayar: number): 'Lunas' | 'Sebagian' | 'Belum' => {
  if (bayar >= total) return 'Lunas';
  if (bayar > 0) return 'Sebagian';
  return 'Belum';
};

export const getSisaBayar = (total: number, bayar: number): number => {
  return Math.max(0, total - bayar);
};

export const formatCurrency = (amount: number): string => {
  return `RM ${amount.toFixed(2)}`;
};

export const getInvoiceColor = (status: string): string => {
  switch (status) {
    case 'Lunas':
      return 'bg-green-100 text-green-700';
    case 'Sebagian':
      return 'bg-yellow-100 text-yellow-700';
    default:
      return 'bg-red-100 text-red-700';
  }
};
